import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Constant } from 'src/app/shared/service/utils/contant';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-compte-budgetaire',
  templateUrl: './compte-budgetaire.component.html',
  styleUrl: './compte-budgetaire.component.scss'
})
export class CompteBudgetaireComponent implements OnInit {

  exercice: number = new Date().getFullYear();

  chapitres: any[] = [];
  sousChapitres: any[] = [];
  comptes: any[] = [];
  paginatedProjets: any[] = [];
  first = 0;
  rows = 10;
  totalRecords = 0;
  isLoading = false;

  selectedChapitre: any = null;
  selectedSousChapitre: any = null;
  item: any = {};
  modalChapitre: any = null;
  modalSousChapitres: any[] = [];

  @ViewChild('compteModal') compteModal: any;

  constructor(
    private modalService: NgbModal,
    private paramService: ParameterService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService
  ) { }

  ngOnInit(): void {
    const stored = this.localStorage.getExerciceToUserToSuivieEvaluation();
    if (stored) {
      this.exercice = Number(stored) || new Date().getFullYear();
    }
    this.loadChapitres();
    this.loadData();
  }

  onExerciceChange(): void {
    this.selectedChapitre = null;
    this.selectedSousChapitre = null;
    this.loadChapitres();
    this.loadData();
  }

  loadChapitres(): void {
    this.paramService.getBordereauChapitres({ annee: this.exercice }).subscribe(
      (response: any) => {
        this.chapitres = response.data || [];
      },
      (error: any) => {
        this.chapitres = [];
      }
    );
  }

  loadSousChapitres(): void {
    this.selectedSousChapitre = null;
    this.paramService.getBordereauSousChapitres({
      annee: this.exercice,
      chapitre_id: this.selectedChapitre || ''
    }).subscribe(
      (response: any) => {
        this.sousChapitres = response.data || [];
      },
      (error: any) => {
        this.sousChapitres = [];
      }
    );
  }

  loadData(): void {
    this.isLoading = false;
    this.ngxService.start();
    this.paramService.getBordereauComptes({
      annee: this.exercice,
      sous_chapitre_id: this.selectedSousChapitre || ''
    }).subscribe(
      (response: any) => {
        this.comptes = response.data || [];
        this.totalRecords = this.comptes.length;
        this.updatePaginated();
        this.isLoading = true;
        this.ngxService.stop();
      },
      (error: any) => {
        this.isLoading = true;
        this.ngxService.stop();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error?.error?.message || 'Une erreur est survenue lors du chargement des comptes'
        });
      }
    );
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePaginated();
  }

  updatePaginated() {
    this.paginatedProjets = this.comptes.slice(this.first, this.first + this.rows);
  }

  openModal(item?: any) {
    this.item = item
      ? { ...item, sous_chapitre_id: item.sous_chapitre?.reference }
      : { sous_chapitre_id: null, annee: this.exercice };
    if (item) {
      this.modalChapitre = item.sous_chapitre?.chapitre?.reference || null;
      this.loadModalSousChapitres();
    } else {
      this.modalChapitre = this.selectedChapitre;
      if (this.modalChapitre) {
        this.loadModalSousChapitres();
      } else {
        this.modalSousChapitres = [];
      }
    }
    this.modalService.open(this.compteModal, { centered: true, backdrop: 'static', size: 'lg' });
  }

  onModalChapitreChange(): void {
    this.item.sous_chapitre_id = null;
    this.loadModalSousChapitres();
  }

  loadModalSousChapitres(): void {
    this.paramService.getBordereauSousChapitres({
      annee: this.exercice,
      chapitre_id: this.modalChapitre || ''
    }).subscribe(
      (response: any) => {
        this.modalSousChapitres = response.data || [];
      },
      (error: any) => {
        this.modalSousChapitres = [];
      }
    );
  }

  onParentChange() {
    const sousChapitre = this.modalSousChapitres.find(s => s.reference === this.item.sous_chapitre_id);
    if (sousChapitre && !this.item.reference) {
      this.item.code = sousChapitre.code;
    }
  }

  save() {
    if (!this.item.sous_chapitre_id || !this.item.code || !this.item.libelle) {
      this.messageService.add({
        severity: 'warn',
        summary: Constant.suiviTitle,
        detail: 'Veuillez renseigner le sous-chapitre, le code et le libellé'
      });
      return;
    }
    this.ngxService.start();
    const reference = this.item.reference;
    this.paramService.saveBordereauCompte(this.item, reference).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.modalService.dismissAll();
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.loadData();
      },
      (error: any) => {
        this.ngxService.stop();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error?.error?.message || 'Une erreur est survenue'
        });
      }
    );
  }

  confirmSuppression(item: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer le compte budgétaire ' + item.libelle + ' ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramService.deleteBordereauCompte(item.reference).subscribe(
          (response: any) => {
            this.ngxService.stop();
            this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
            this.loadData();
          },
          (error: any) => {
            this.ngxService.stop();
            this.messageService.add({
              severity: 'error',
              summary: Constant.suiviTitle,
              detail: error?.error?.message || 'Une erreur est survenue'
            });
          }
        );
      }
    });
  }
}
